import React, { useContext } from "react";
import { Modal } from "antd";
import closeIconModal from "../assets/closeIconModal.svg";
import { ThemeContext } from "./themeContext";

const CampaignModal = ({
  open,
  onCancel,
  title,
  subtitle,
  actionLabel,
  actionIcon,
  onAction,
  children,
  actionDisabled = false,
  customFooter,
}) => {
  const { theme } = useContext(ThemeContext);
  const themeClass = theme === "healthCare" ? "healthcare" : "primecare";
  return (
    <Modal
      open={open}
      onCancel={onCancel}
      footer={null}
      closeIcon={null}
      className={`campaign-modal-custom-width ${themeClass}`}
    >
      <div className="d-flex align-items-center justify-content-between">
        <h2 className="clone-modal-title">{title}</h2>
          {/* <img
            src={closeIconModal}
            alt="Close"
            className="cursor-pointer"
            onClick={onCancel}
          /> */}
      </div>
      {subtitle && <p className="campaign-modal-subtitle">{subtitle}</p>}
      <hr className="my-3" />

      {children}

      {customFooter !== undefined ? (
        customFooter
      ) : (
        <div className="d-flex justify-content-end gap-3 mt-4">
          <button
            type="button"
            class="cancelbtn primarybtn campaignBtn fs-18 "
            onClick={onCancel}
          >
            Cancel
          </button>
          <button
            type="button"
            class=" primarybtn fs-18 campaignBtn gap-2 align-items-center"
            onClick={onAction}
            disabled={actionDisabled}
          >
            {actionIcon}
            {actionLabel}
          </button>
        </div>
      )}
    </Modal>
  );
};

export default CampaignModal;
